 export  enum FilterType {
    None = 0,
    All = 1,
    My = 2
  }